import React, { useState, useEffect, useContext } from 'react';
import '../Styles/Login.scss';
import Logo from '../Images/ht_logo_final.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import useFetch from '../CustomHooks/useFetch';
import { validateEmail } from '../Util/ValidateEmail';
import { makeStyles } from '@material-ui/core/styles';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [response, fetchData] = useFetch();
    const classes = useStyles();
    const [errorMessages, setErrorMessages] = useState({ email: '', yourName: '', restaurantName: '', password: '', passwordAgain: '' });
    const [guiLanguage, setGuiLanguage] = useState('en');


    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )


    const setErrorMessage = (key, value) => {
        setErrorMessages({ ...errorMessages, [key]: value });
    }

    const submitForm = async (e) => {
        e.preventDefault();

        let validated = true;

        if (!validateEmail(email)) {
            setErrorMessage('email', 'Please enter a valid email.');
            validated = false;
        }
        else {
            setErrorMessage('email', '');
        }

        if (validated) {
            fetchData(
                {
                    url: '/admin/auth/send-reset-password-email',
                    method: 'POST',
                    postData: {
                        email: email,
                    },
                }
            )
        }
    }

    useEffect(
        () => {
            async function f() {
                console.log(response.length);

                if (response.length != 0) {
                    if (response) {

                        console.log(response);

                    }
                    else {
                        console.log(response)
                    }
                }

            }
            f();
        }, [response]
    )

    return (
        <div className="login">
            <div className={classes.innerWrapper}>
                {response.length == 0 ?
                    <React.Fragment>
                        <img src={Logo} className={classes.logoImage}></img>
                        <div style={{ marginTop: '20px' }}>
                            {
                                guiLanguage == 'tr' ?
                                    'Parolanızı yenilemeniz için size bir e-posta göndereceğiz.'
                                    :
                                    'We will send you a passsword reset e-mail.'
                            }
                            </div>
                        <TextField id="username" 
                        label= {guiLanguage == 'tr' ? 'e-posta adresiniz' :'e-mail'}
                        value={email} onChange={(e) => setEmail(e.target.value)} 
                        helperText={guiLanguage == 'tr' ? 'Geçerli bir e-posta adresi girin' :'Enter a valid e-mail'} error={errorMessages.email == '' ? false : true} />
                        <Button id="submitButton" variant="contained" color="primary" style={{ marginTop: '30px' }} onClick={submitForm}>
                        {
                                guiLanguage == 'tr' ?
                                    'Parola yenileme gönder'
                                    :
                                    'Send reset password'
                            }
                            
                        </Button>
                    </React.Fragment>
                    : null}
                {response.length != 0 && response ?
                    <div className="sent-you-forgot-password">
                            {
                                guiLanguage == 'tr' ?
                                    'Parolanızı yenilemeniz için size bir e-posta gönderdik.'
                                    :
                                    'We have just sent you an e-mail with a password reset link. Please check your e-mail. Please do not forget to check your spam folder if the password e-mail is not in your inbox.'
                            }
                        
                        </div>
                    : null}
                {response.length != 0 && !response ?
                    <div className="no-such-mail">
                        {
                                guiLanguage == 'tr' ?
                                    'Veritabanımızda böyle bir e-posta adresi yok. Lütfen e-posta adresinizi kontrol edin.'
                                    :
                                    'There is no such e-mail address on our database. Please check your e-mail and try again.'
                            }
                        </div>
                    : null}
            </div>
        </div>
    );
}


const useStyles = makeStyles({
    logoImage: {
        width: '300px',
        alignSelf: 'center',
    },
    innerWrapper: {
        width: '300px',
        display: 'flex',
        flexDirection: 'column',
        marginTop: '150px',
    }
});